import { ItemPerPage } from '@core/models/file-response.model';
import { PaymentStatus } from '@core/models/booking.model';

export const DEFAULT_PP = 'assets/images/profile_placeholder.png';
export const DEFAULT_USERNAME = '';
export const DEFAULT_COMPANY_PP = 'assets/images/Company_logo_palceholder.svg';
export const NAME_VALIDATION_PATTERN =
/^[A-Za-z !@#$%^&*()\-_=+[\]{}|;:'",.<>/?]*$/;
export const MULTILINGUAL_NAME_VALIDATION_PATTERN = /^[\p{L}\s]+$/u;
export const EMAIL_VALIDATION_PATTERN =
  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const ALLOW_NUMBER_ALPHABET =
  /^[a-zA-Z!@#$%^&*()_+{}\[\]:;"'<>,.?/\\|-]*$/;
export const IMG_EXTENSIONS = ['jpg', 'jpeg', 'png'];
export const VALID_PARKING_LAYOUT_EXTENSIONS = ['jpg', 'jpeg', 'png'];
export const DEFAULT_REWIER_PP = 'assets/images/reviewer_default_img.svg';
export const DEFAULT_LATITUDE = 40.7444618;
export const DEFAULT_LONGITUDE = -96.104146;
export const DECIMAL_VALIDATION_PATTERN = /^\d+(\.\d{1,2})?$/;
export const NO_IMAGE = 'assets/images/no-image.svg';
export const DEFAULT_LOGO = 'assets/images/default_logo.png';
// Messages
export const INVALID_PARKING_LAYOUT_FORMAT =
  'Invalid format for parking layout plan uploaded. Please ensure you are using a supported file format (e.g.JPG,JPEG, PNG) and try again.';
export const Invalid_IMAGE_FORMAT =
  'Invalid format for image uploaded. Please ensure you are using a supported file format (e.g., JPEG, JPG, PNG) and try again. ';
export const MSG_CREATE_PARKING =
  'Your parking location has been successfully created.';
export const MSG_UPDATE_PARKING =
  'Your parking location has been successfully updated.';
export const MSG_DELETE_PARKING =
  'Your parking location has been deleted successfully.';
export const MSG_DELETE_VEHICLE_INFO =
  'Your equipment information has been deleted successfully.';
export const MSG_DELETE_VEHICLE = 'Are you sure that you want to delete?';
export const MSG_DELETE_PARKING_CONFIRMATION =
  'Are you sure that you want to delete?';
export const MSG_DELETE = 'Are you sure that you want to delete?';
export const MSG_DELETE_EQUIPMENT =
  'Are you sure that you want to remove this equipment?';
export const MSG_DELETE_RECURRING =
  'Are you sure you want to cancel the recurring subscription?';
export const MSG_CANCEL_BOOKING =
  "A saved payment method is required in user's profile to create invoice for recurring booking. Please contact the user to add a card or a bank account in their Trucklots profile.";
export const MSG_CREATE_INVOICE_ERROR =
  'You cannot create Invoice for One Time Booking';
export const UNDER_MAINTANCE_ERROR =
  'Please select both Start and End Dates with Times.';
export const SELECT_BOTH_DATES = 'Please select both Start and End Dates.';
export const UNDER_MAINTANCE_TODAYDATE =
  'Start Time should be greater than or equal to the Current Time for today.';
export const UNDER_MAINTANCE_GREATERTIME =
  'End Date and Time should be greater than Start Date and Time';
export const ARRIVAL_DEPARTURE_GREATERTIME =
  'Departure Date and Time should be greater than Arrival Date and Time';
export const END_DATE_GREATER = 'End Date should be greater than Start Date';
export const MSG_Confirmation =
  'Are you sure you want to delete your existing bank account information?';
export const MSG_EmailExist = 'Please enter a valid email*';
export const MSG_CONGRATS_PARKING =
  'You have successfully completed the first step of the Onboarding process. Your information has been shared with the Trucklots team, and they will reach out to you shortly via email.';
export const MSG_EMAIL_INCORRECT =
  'The email entered is incorrect, please enter a valid email.';
export const logo = 'assets/images/logo-menu.png';
export const account = 'assets/images/Account.png';
export const Under_MaintAnce_Confirmation =
  'Are you sure you want to switch to other model? Under Maintenance data with current model will be lost.';
export const tooltipHalpLengthMessage =
  '<div class="half-length"><p><b>Half-Length Spot (12x40 ft):</b> This category is designed for smaller trucks, vans, and trailers that require less space. Typically, these spots accommodate vehicles that are up to 40 feet in length. These spots are most suitable for compact or medium-sized trucks that don’t need the extended space of a full-length spot.</p></div>';
export const tooltipFullLengthMessage =
  '<div class="half-length full-length"><p><b>Full-Length Spot (12x75 ft):</b> This category is designed for larger trucks and trailers, providing ample space for vehicles that are up to 75 feet long. These spots provide the necessary room for heavy-duty vehicles that require more space for parking, loading, or unloading.</p></div>';
export const lpMessage = `<p> You can add multiple LP Numbers separated by commas. (e.g. 658987855, 4555455555)</p>`;
export const RESNET_PASSWPRD_MSG = 'Passcode resent successfully!';
export const CONFIRM_PASSWORD_MATCH_MESSAGE =
  'Confirm Password should match the New Password';
export const UPD_PASSWORD_MSG = 'Password Updated Successfully';
export const PASSCODE_ENTER_MSG = 'Please enter 6-digit Passcode';
export const SPOT_TYPE_LABEL = 'Spot Type';
export const EQUIPMENT_INFORMATION_LABEL = 'Equipment Information';
export const ADD_SPOT_LABEL = 'Add Spot';
export const ADD_EQUI_LABEL = 'Add Equipment';
export const MARK_AS_PAID_MSG =
  'Are you sure you want to mark this</br> booking as paid?';
export const CREATE_INVOICE_MSG =
  'The booking has been created successfully and an invoice has been sent via email.';
export const defaultParkingLotImage = 'assets/images/default-parkingLot.svg';
export const CANCEL_INVOICE_CONFIRMATION =
  'Are you sure you want to cancel the invoice?';
export const CANCEL_BOOKING_CONFIRMATION =
  'Are you sure you want to cancel the booking?';
export const CANCEL_BOOKING_CONFIRMATION_MODEL =
  'Are you sure you want to <br/> cancel the booking?';
export const MSG_BOOKING_CONFIRMATION =
  'Booking confirmation will be sent shortly.';
export const MSG_CUSTOM_INVOICE_CONFIRMATION =
  'Email confirmation will be sent shortly.';
export const MSG_CREATED_BOOKING_SUCCESSFULLY =
  'Your booking has been created successfully.';
export const PAYMENT_LINK_SHARED_MSG =
  'Payment link has been shared successfully.';
export const CANCEL_INVOICE_CONFIRMATION_MODEL =
  'Are you sure you want to <br/> cancel the invoice?';
export const RESET_PASSWORD_CONFIRMATION =
  'Are you sure you want to <br /> reset the password?';
export const MSG_DELETE_ACCOUNT = 'Are you sure you want to delete account?';
export const OCCUPANCY_TOOLTIP_MESSAGE = `This represents the percentage of occupied spot-hours out of the total available spot-hours for the parking lot for the current month till date.`;
export const DATE_RANGE_MESSAGE = `You can specify a date to filter the data based on your preferences.`;
export const DASHBOARD_DATE_RANGE_MESSAGE = `Data is filtered based on the booking date. Select a date range to view relevant records.`;
export const INVOICE_PAYMENT_STATUS_UPDATE = 'Invoice Payment Status Update';
export const MOBILE_TOOLTIP_MSG =
  'You may enter your registered email or 10-digit mobile number without country code.';
export const CONTACT_ERR_MSG =
  'Please provide either an Email or a Mobile number.';
export const EMAIL_REQUIRED_MSG_CREATE_INVOICE =
  "User's Email is required to create an invoice. Please update user's profile and try again.";
export const DEFAULT_PAYMENT_MSG =
  'A default payment method is required to create a recurring booking.';
export const VERIFY_ACCOUNT_MSG = 'Please verify your account';
export const LOGIN_SUCCESSFUL_MSG = 'Login Successful';
export const EQUIPMENT_INFO_DELETED_MSG =
  'Equipment information has been deleted successfully.';
export const MARK_AS_PAID_CONFIRMATION =
  'Are you sure you want to mark this as paid?';
export const CUSTOM_INVOICE = 'Custom Invoice';
export const OPENGATE_ERROR_MESSAGE_DEVICE_NOT_CONNECTED =
  'Device ID is not connected.';
export const BOOKING_CANCELLATION_PROMPT =
  'Please select what would you like to cancel:';
export const INVALID_BOOKING_ID = 'Invalid Booking Id';
export const SPOT_REDUCTION_MSG =
  'The number of spots has been reduced. Please update the list of drivers and their equipment to match the total spots.';
export const MATCH_ERROR_MSG =
  'This Parker is assigned to an existing booking. You would need to remove the Parker from booking separately. Do you really want to remove this Parker from your profile?';
export const SESSION_EXPIRED_MSG =
  'Your session has expired. Please login again.';
export const PAY_REPAY_SCHEDULE_SUCCESS_MSG =
  'Payment for the booking is scheduled successfully!';
export const BOOKING_CANCEL_SCHEDULE_SUCCESS_MSG =
  'Booking cancellation is scheduled successfully!';
export const CANCEL_BOOKING_SCHEDULE_MESSAGE =
  'The booking is scheduled for cancellation on';
export const REATTEMPT_PAY_REPAY_SCHEDULE_MESSAGE =
  'The booking is scheduled for Repayment on';
export const RE_SCHEDULE_WARNING_MESSAGE =
  'If you schedule this booking again, the existing scheduled values will be overridden.';
export const CANCEL_BOOKING_CONFIRMATION_MODAL = {
  withRefund: {
    title: 'Cancel current booking <b>with refund</b>',
    message:
      'Are you sure you want to cancel this booking and initiate refund?',
  },
  withoutRefund: {
    title: 'Cancel current booking <b>without refund</b>',
    message: 'Are you sure you want to cancel this booking?',
  },
  subscriptionOnly: {
    title: 'Cancel upcoming billing cycle',
    message: 'Are you sure you want to cancel upcoming billing cycle?',
  },
};

export const SCHEDULE_OPTION_TITLE = {
  scheduledOption: {
    title:
      'Would you like to schedule date & time for the selected cancel type? <br /><b>(Optional)</b>',
    payRepayTitle:
      'Would you like to schedule the repay date & time for this booking? <b>(Optional)</b>',
  },
};
export const BOOKING_CREATED_SUCCESS_MSG =
  'Booking has been created successfully.';
export const SCHEDULE_PAY_REPAY_OPTION =
  'Would you like to schedule the repay date & time for this booking? (Optional)';
export const REATTEMPT_STARTED_MSG = 'Reattempt';
export const PROCESSING_DELAY_MSG =
  'Are you sure you want to reattempt <br />all the failed and pending payments?';
export const SPOT_INCEASE_DECREASE_SUCCSESS_MSG =
  'Spot count has been updated successfully! Please update assigned parker list for this booking with new spot count.';
export const SOPT_INCREASE_ACH_PAYMENT_SUCCESS_MSG =
  'Spot Count will get updated as soon as payment is processed successfully. Please update assigned parker list for this booking with new spot count when payment gets paid.';
export const SPOT_INCREASE_PAYMENT_FAILED_MSG =
  'The payment attempt was unsuccessful. Spot count remains unchanged. Please re-initiate the process to update the spot count.';
export const PAY_REPAY_PAYMENT_CONFIRMATION_MSG =
  'Are you sure you want to make the payment using the selected preferred payment method?';
export const DEPARTURE_DATE_TOOLTIP_MSG = `The departure time will be automatically determined based on the arrival time.`;
export const USER_CONVERTED_TO_GROUP_OPERATOR_MSG =
  'Are you sure you want to change the role from Parker to Group Operator?';
export const USER_CONVERTED_TO_GROUP_OPERATOR_SUCCESS_MSG =
  'The role transition from Parker to Group Operator is completed successfully.';
export const DECREASE_SPOT_MSG =
  'Are you sure you want to decrease the spots in the next billing cycle?';
export const INCREASE_SPOT_MSG =
  'Are you sure you want to increase the spots in the next billing cycle?';
export const BOOKING_STATUS_LABELS = {
  PAID: 'Paid',
  CANCELLED: 'Cancelled',
};
export const PAYMENT_MODE = {
  ONLINE: 'Online',
  OFFLINE: 'Offline',
};
export const USER_ROLES = {
  SUPER_ADMIN: 'SuperAdmin',
  PARKING_MANAGER: 'ParkingManager',
  PARKING_OWNER: 'ParkingOwner',
  DRIVER: 'Driver',
  GROUP_USER: 'GroupUser',
};

export const USER_TYPE = {
  DRIVER: 'Driver',
  GROUP_OPERATOR: 'Group Operator',
};
export const UPDATED_USER_TYPE = {
  PARKER: 'Parker',
  GROUP_OPERATOR: 'Group Operator',
};

export const ROUTES = {
  SUPER_ADMIN: 'super-admin',
  MANAGER: 'manager',
  DRIVER: 'driver',
  GROUP_OPERATOR: 'group-operator',
};
export enum TypeOfPendingPayment {
  Booking = '1',
  DeferredInvoice = '2',
  CustomInvoice = '3',
}
export enum BookingPaymentMode {
  PayNow = 1,
  PayOffline = 2,
}
export enum GroupUserDriverList {
  All = 1,
  UnAssigned = 2,
}
export const PaymentOptions = [
  {
    value: 1,
    title: 'Pay in Trucklots',
    description: 'Proceed with the payment.',
  },
  {
    value: 2,
    title: 'Pay Offline',
    description: 'Mark payment as paid.',
  },
];

export enum UserListOption {
  All = 1,
  UsersWithActiveBooking = 2,
}

const JUNE = 'Jun';
const JULY = 'Jul';

export const getMonthAbbreviation = (month: string): string => {
  const monthAbbreviation = month?.slice(0, 3);
  return [JUNE, JULY].includes(monthAbbreviation) ? month : monthAbbreviation;
};

export const itemsPerPageList: ItemPerPage[] = [
  // Item per page list with interface for grid
  { name: '10', value: 10 },
  { name: '20', value: 20 },
  { name: '30', value: 30 },
  { name: '40', value: 40 },
  { name: '50', value: 50 },
  { name: '60', value: 60 },
  { name: '70', value: 70 },
  { name: '80', value: 80 },
  { name: '90', value: 90 },
  { name: '100', value: 100 },
];

export const PaymentStatusOption = [
  { name: 'All', value: PaymentStatus.All },
  { name: 'Paid', value: PaymentStatus.Completed },
  { name: 'Pending', value: PaymentStatus.Pending },
  { name: 'Payment Failed', value: PaymentStatus.Failure },
  { name: 'In-Process', value: PaymentStatus.Processing },
  { name: 'Cancelled', value: PaymentStatus.Cancelled },
  { name: 'Scheduled', value: PaymentStatus.Scheduled },
  { name: 'Disputed', value: PaymentStatus.Disputed },
];

export enum UserRole {
  Parker = 0,
  GroupOperator = 4,
  Both = null,
}
export enum SpotUpdateType {
  NoChange = 0,
  Increase = 1,
  Decrease = 2,
}
export interface TimeOption {
  name: string;
  value: any;
}

export enum PaymentMethodType {
  Card = 1,
  ACH = 2,
}
export const locationStatus = [
  { name: 'All', key: 4 },
  { name: 'Active', key: 1 },
  { name: 'Coming Soon', key: 2 },
];

export const cancellationReasons = [
  'Found Another Location Closer to Home',
  'Cost Concern',
  'Business Change (sold truck, retiring, changed jobs, etc.)',
  'Moving',
  'Customer Service Concern',
  'Other',
];

export const cancellationBookingValidationMessage = {
  radioButtonValidation: 'Please select the type of cancellation.',
  reasonDropDownValidation: 'Please select a reason for cancellation.',
  additionalCommentValidation:
    'Please add an additional note for the selected reason.',
};

export enum ParkingLotRating {
  DefinitelyWouldNotRecommend = 1,
  UnlikelytoRecommend = 2,
  Neutral = 3,
  LikelytoRecommend = 4,
  DefinitelyWouldRecommend = 5,
}

export const ratings = [
  {
    label: 'Definitely Would Recommend',
    emoji: '../../../assets/images/definitely-moji.svg',
    desc: 'Excellent experience; would confidently recommend to others.',
  },
  {
    label: 'Likely to Recommend',
    emoji: '../../../assets/images/unlikely-moji.svg',
    desc: 'Overall good experience; would recommend with minor reservations.',
  },
  {
    label: 'Neutral',
    emoji: '../../../assets/images/neutral-moji.svg',
    desc: 'It was fine, but not great—might or might not recommend.',
  },
  {
    label: 'Unlikely to Recommend',
    emoji: '../../../assets/images/likely-moji.svg',
    desc: `Several issues; wouldn't feel comfortable referring someone.`,
  },
  {
    label: 'Definitely Would Not Recommend',
    emoji: '../../../assets/images/definitely-not-moji.svg',
    desc: 'Had a very negative experience.',
  },
];

export const bookingStatusMatchStringValue = {
  Pending: 'Pending',
  Completed: 'Completed',
  Cancelled: 'Cancelled',
};
export enum BookingCycleOption {
  Current = 1,
  NextBillingCycle = 2,
}

export const BOOKING_CYCLE_DROPDOWN = [
  { label: 'Current', value: BookingCycleOption.Current },
  { label: 'Next Billing Cycle', value: BookingCycleOption.NextBillingCycle },
];

export interface Rating {
  label: string;
  emoji: string;
  desc: string;
}
